import { formatLakhs } from "../../../common/utils/formatters";
import {
  COVER_AMOUNT_RUPEE_STEP,
  MIN_COVER_ELITE,
  MIN_COVER_PLUS,
  PLAN_NAMES,
} from "../../../constants";

/**
 * Generate 4 cover options (70%, 80%, 90%, 100% of max), clamped to product minimum and capped at max.
 */
export const generateCoverAmountOptions = (maxCoverAmount, selectedPlan) => {
  if (!maxCoverAmount) return [];
  const max = Number(maxCoverAmount);
  if (isNaN(max)) return [];
  const isElite = selectedPlan === PLAN_NAMES.ELITE;
  const minCover = isElite ? MIN_COVER_ELITE : MIN_COVER_PLUS;
  const options = [];
  for (let i = 0; i < 4; i++) {
    const pct = 1 - i * 0.1;
    const value =
      Math.round((max * pct) / COVER_AMOUNT_RUPEE_STEP) *
      COVER_AMOUNT_RUPEE_STEP;
    const clamped = Math.min(max, Math.max(value, minCover));
    if (clamped > 0)
      options.push({ value: clamped, label: formatLakhs(clamped) });
  }
  const byValue = new Map();
  options.forEach((o) => byValue.set(o.value, o));
  return [...byValue.values()].sort((a, b) => a.value - b.value);
};

/** Default Life Cover radio: last option (100% of max / highest SA tier). */
export const getDefaultSelectedCoverAmount = (coverAmountOptions) => {
  if (!Array.isArray(coverAmountOptions) || coverAmountOptions.length === 0) {
    return null;
  }
  return coverAmountOptions[coverAmountOptions.length - 1].value;
};
